import { Box, Flex, useDisclosure } from "@chakra-ui/react";
import React from "react";
import {
  PageHeadingContainer,
  PageContainerPx,
  PageContainerPy,
} from "../components/atoms/Containers";
import { PageHeading } from "../components/atoms/Headings";
import {
  PageHeadingTagContainer,
  PageHeadingTag,
} from "../components/molecules/PageHeadingTag";
import { AddTransactionDrawer } from "../components/organisms/transaction/addTransaction/AddTransactionDrawer";
import { hasActiveFilters } from "../components/organisms/transaction/mainTransactionTable/filters/hasActiveFilters";
import { SelectedTxContextProvider } from "../components/organisms/transaction/mainTransactionTable/SelectedTxContext";
import { TransactionsView } from "../components/organisms/transaction/mainTransactionTable/TransactionsView";
import { useElementWidth } from "../hooks/useElementWidth";
import { useTransactionsStore } from "../store/transactionsStore";
import { useQueryGetAccountTransactionCount } from "../store/useQueryGetAccountTransactionCount";
import { SCREEN_SIZE } from "../theme/foundations/breakpoints";

export const Transactions = () => {
  const addTransactionDisclosure = useDisclosure();

  const queryAccountTransactionCount = useQueryGetAccountTransactionCount();

  const groupListTotal = useTransactionsStore((state) => state.groupListTotal);

  const filtering = useTransactionsStore((state) =>
    state.groupListProps ?
      hasActiveFilters(state.groupListProps.filter)
    : false,
  );

  const availableTxCount =
    filtering ? groupListTotal : queryAccountTransactionCount.data;

  const pageContainerWidth = useElementWidth<HTMLDivElement>();

  const groupListIds = useTransactionsStore((state) => state.groupList);

  // styling on the page container/ layout is very different on this page due
  // to the use of sticky positioning for the table.
  return (
    <Flex overflow="auto" ref={pageContainerWidth.ref} direction="column">
      <Box maxW={SCREEN_SIZE.XXL} w="max-content" py={PageContainerPy}>
        <PageHeadingContainer
          w={`${pageContainerWidth.width}px`}
          position="sticky"
          left={0}
          px={PageContainerPx}
        >
          <PageHeadingTagContainer>
            <PageHeading>Transactions</PageHeading>
            {queryAccountTransactionCount.data != null && (
              <PageHeadingTag>
                {filtering && groupListTotal != null ?
                  `${groupListTotal.toLocaleString()} of `
                : ""}
                {queryAccountTransactionCount.data.toLocaleString()}
              </PageHeadingTag>
            )}
          </PageHeadingTagContainer>
        </PageHeadingContainer>

        <SelectedTxContextProvider
          availableTransactionCount={availableTxCount}
          availableGroupIds={groupListIds}
        >
          <TransactionsView
            pageContainerWidth={`${pageContainerWidth.width}px`}
            onAddTransaction={addTransactionDisclosure.onOpen}
            totalTransactionCount={queryAccountTransactionCount.data}
          />
        </SelectedTxContextProvider>

        {addTransactionDisclosure.isOpen && (
          <AddTransactionDrawer disclosure={addTransactionDisclosure} />
        )}
      </Box>
    </Flex>
  );
};
